import { createRoot } from "react-dom/client";
import Main from "./ui/Main";
import ProCon from "./ui/ProCon";

try {
    const root = createRoot(document.getElementById("root"));
    const isProConPage = window.location.pathname === "/procon" || window.location.pathname === "/procon/";

    root.render(isProConPage ? <ProCon /> : <Main />);
} catch (error) {
    console.error("Failed to render Main component:", error);
}
